export enum MODAL_TYPE {
  SHOW_DETAILS = 'showDetails',
  TRACK_ORDER = 'trackOrder',
}
